import { render, staticRenderFns } from "./OrderCountTrend.vue?vue&type=template&id=291f220d&scoped=true"
import script from "./OrderCountTrend.vue?vue&type=script&lang=js"
export * from "./OrderCountTrend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "291f220d",
  null
  
)

export default component.exports